/* eslint 'jsx-a11y/anchor-is-valid': 'off' */
import React, { Component } from "react";
import { connect } from 'react-redux';
import {  Button, Table } from 'reactstrap';
import { createFilter } from 'react-search-input';
import DatePicker from "react-datepicker";
import '../../../Assets/EnsembleStyles/BillingInvoices.css';
import {FaRegCalendarAlt} from 'react-icons/fa';
import ASUBuildingInvoiceDetails from './ASUBuildingInvoiceDetails';
import { GetAllCampusInvoices, GetCampusBillingFilters, ASUGenerateSummaryInvoice, DownlodBuildingInvoiceExcel } from '../../../action/ASU/BillingInvoicesAction';
import ReactPaginate from 'react-paginate';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
//import DownloadInvoice from '../../../Assets/icons/DownloadInvoice.svg';
import Conversions from '../../../Resources/Conversions';
//import { FaPrint } from 'react-icons/fa';
import ASULogo from '../../../Assets/images/ASU-logo-horizontal_02.png';
import {Icon} from 'semantic-ui-react';


const KEYS_TO_FILTERS = ['siteName', 'campus', 'on_Peak_kw', 'off_Peak_kw', 'kWh_Total', 'kWh_Cost', 'tonHr_Total', 'tonHr_Cost', 'heating_mmBTU', 'heating_mmBTU_Cost', 'total_mmBTU', 'om_Utility_Service_Charge', 'om_Capital_Service_Charge', 'sewer_Service_Charge', 'water_Service_Charge', 'total_Cost'];
const ErrorPadding ={
    color:'#D42D27',
    fontfamily:'Lato',
    fontSize:'13px',
    fontStyle:'italic',
    border:'2px solid #D42D27',
    height:'40px',
    padding:'10px',
    float:'right',
    marginTop:'-5px',
    marginBottom:'5px'    
};
const ErrorSign ={
    color:'#D42D27',
    paddingLeft:'8px',
    paddingTop:'0px',
    paddingRight:'14px',
    width:'22px',
    height:'22px',
    top:'406px',
    left:'959px'
};
var FilterDt = new Date(),selectedASUCampus;
FilterDt.setDate(1);
FilterDt.setMonth(FilterDt.getMonth()-1);
let pagesCount = 0, PrintPaginationText = '',dateformat = "";
class ASUInvoices extends Component {
    
    componentWillMount() {
        selectedASUCampus = [];
        this.props.GetCampusBillingFilters();
        //default filter : current year and previous month
       // this.props.GetAllCampusInvoices(new Date().getMonth(),new Date().getFullYear(),null);
        var FilterDetails = sessionStorage.getItem('ASUInvoiceTabFilter');
        if (FilterDetails !== undefined && FilterDetails !== null && FilterDetails !== "null") {
            var lFilterDetails = JSON.parse(FilterDetails);  
            lFilterDetails.Invoicefiltervalue !== undefined ? this.setState({ FilterCampusValue: lFilterDetails.Invoicefiltervalue }) : this.setState({ FilterCampusValue: null });          
            this.props.GetAllCampusInvoices(lFilterDetails.InvoiceFilterMonth,lFilterDetails.InvoiceFilterYear,lFilterDetails.Invoicefiltervalue);
            var FilterDt1 = new Date();
            FilterDt1.setDate(1);
            FilterDt1.setMonth(lFilterDetails.InvoiceFilterMonth -1);
            FilterDt1.setFullYear(lFilterDetails.InvoiceFilterYear);
            this.setState({ FilterDate: FilterDt1, currentPage: 0 });
        }
        else {
            this.props.GetAllCampusInvoices(new Date().getMonth(),new Date().getFullYear(),null);
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0,
            pageSize: 50,
            searchTerm: "",
            FilterCampusValue : null,
            redirect : false,
            building : 0,
            isError: false,
            FilterDate: new Date(FilterDt),
            columnDefs: [
                {
                    headerName: "", width: 50, field: "checkboxfield", cellStyle: { 'padding-top': '12px' }, pinned: 'left', sortable: false, cellRenderer: (params) => {
                        var link = document.createElement('input');
                        link.type = 'checkbox';
                        link.checked = params.value;
                        link.value = params.data.building;
                        link.className = "ASUBuildingInvoiceGeneration";
                        link.addEventListener('click', (e) => { 
                            params.value =! params.value;
                            params.node.data.fieldName = params.value;
                            this.onSelectionChanged()
                        });
                        return link;
                    }
                },
                { headerName: "Building", field: "siteName",width:250,pinned: 'left',sort: 'asc', sortingOrder: ['asc', 'desc'], cellStyle: {color:'#6890C6','text-decoration':'underline'}, tooltip: (params) => params.value, cellRenderer: (params) => {
                    var link = document.createElement('a');
                    link.href = '#';
                    link.innerText = params.value;
                    link.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.ViewCampusBuildingInvoiceDetails(params.data.building, params.data.siteName);
                    });
                    return link;
                    } },
                { headerName: "Campus", field: "campus", width:80,  tooltip: (params) => params.value, sortable: false },
                { headerName: "On-Peak kW", field: "on_Peak_kw", tooltip: (params) => params.value, sortingOrder: ['asc', 'desc'], cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator },
                { headerName: "Off-Peak kW", field: "off_Peak_kw", tooltip: (params) => params.value, sortingOrder: ['asc', 'desc'],  cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "kWh Total", field: "kWh_Total", tooltip: (params) => params.value, sortingOrder: ['asc', 'desc'], cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "kWh Cost", field: "kWh_Cost",tooltip: (params) => params.value, sortingOrder: ['asc', 'desc'], cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "TonHr Total", field: "tonHr_Total",tooltip: (params) => params.value, sortingOrder: ['asc', 'desc'],  cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "TonHr Cost", field: "tonHr_Cost",tooltip: (params) => params.value, sortingOrder: ['asc', 'desc'],  cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "Heating mmBTU", field: "heating_mmBTU",tooltip: (params) => params.value, sortingOrder: ['asc', 'desc'],  cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "Heating mmBTU Cost", field: "heating_mmBTU_Cost",tooltip: (params) => params.value,sortingOrder: ['asc', 'desc'],  cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "Total mmBTU", field: "total_mmBTU", tooltip: (params) => params.value, sortingOrder: ['asc', 'desc'], cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "O&M Utility Service Charge", tooltip: (params) => params.value, field: "om_Utility_Service_Charge",headerTooltip: 'O&M UTILITY SERVICE CHARGE', sortingOrder: ['asc', 'desc'], cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "O&M Capital Service Charge", tooltip: (params) => params.value, field: "om_Capital_Service_Charge",headerTooltip: 'O&M CAPITAL SERVICE CHARGE', sortingOrder: ['asc', 'desc'], cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "Sewer Service Charge", tooltip: (params) => params.value, field: "sewer_Service_Charge", sortingOrder: ['asc', 'desc'], cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "Water Service Charge", tooltip: (params) => params.value, field: "water_Service_Charge", sortingOrder: ['asc', 'desc'], cellClass:'ag-cell-alignment', headerClass:'ag-header-alignmnet',comparator: this.NumberComparator},
                { headerName: "Total Cost", field: "total_Cost",pinned: 'right',tooltip: (params) => params.value, sortingOrder: ['asc', 'desc'], cellStyle: {'text-align':'center','font-weight':'bolder'},headerClass:'ag-header-alignmnet',comparator: this.NumberComparator}]
        };
        this.OnFilterCampusChange = this.OnFilterCampusChange.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.OnFilterChange = this.OnFilterChange.bind(this);
        this.ViewCampusBuildingInvoiceDetails = this.ViewCampusBuildingInvoiceDetails.bind(this);
        this.setFilterDate = this.setFilterDate.bind(this);
        this.onFilterCalendarOpen = this.onFilterCalendarOpen.bind(this);
        this.onFilterCalendarClose = this.onFilterCalendarClose.bind(this);
        this.handlePrevYearChange = this.handlePrevYearChange.bind(this);
        this.handleNextYearChange = this.handleNextYearChange.bind(this);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.OpenPrintPreview = this.OpenPrintPreview.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
    }

    NumberComparator(Number1, Number2) { 
        Number1 = Number1.replace('$',"");
        Number2 = Number2.replace('$',"");

        let PreferedDateFormat = dateformat;
        var n1 = Conversions.getInvariantNumber(PreferedDateFormat, Number1);
        var n2 = Conversions.getInvariantNumber(PreferedDateFormat, Number2);      

        return (n1 - n2);
    }

    OnFilterCampusChange(){
        var selectedOption = this.refs.campus_in_Select_input.options.selectedIndex;
        var lFilterId = this.refs.campus_in_Select_input.options[selectedOption].id;
        lFilterId = lFilterId === "All" ? null : lFilterId;
        this.setState({ FilterCampusValue : lFilterId });
    }

    searchUpdated(){
        this.setState({ searchTerm: this.refs.asu_campus_search_value.value, currentPage: 0 });
    }

    OnFilterChange() {
        selectedASUCampus = [];
        var Data = ({ 'Invoicefiltervalue': (this.state.FilterCampusValue !== undefined ? this.state.FilterCampusValue : null),'InvoiceFilterMonth': this.state.FilterDate.getMonth()+1,'InvoiceFilterYear':this.state.FilterDate.getFullYear() });
        sessionStorage.setItem('ASUInvoiceTabFilter', JSON.stringify(Data));   
        this.props.GetAllCampusInvoices(this.state.FilterDate.getMonth()+1,this.state.FilterDate.getFullYear(),(this.state.FilterCampusValue !== undefined ? this.state.FilterCampusValue : null)).then(() => {
            this.setState({ currentPage: 0 });
        });
    }

    ViewCampusBuildingInvoiceDetails(building, siteName) {
       
        this.setState({ redirect: true, building: building, siteName: siteName });
    }

    UpdateRedirection()
    {
        this.setState({ redirect: false});
    }

    setFilterDate(date){
        this.setState({ FilterDate : date });
        this.onFilterCalendarClose();
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onSelectionChanged(){
        var checkboxes = document.getElementsByClassName('ASUBuildingInvoiceGeneration');
        for(var i = 0; i < checkboxes.length; i++ ){
            for(var j = 0; j < selectedASUCampus.length; j++ ){
                if(selectedASUCampus[j].building === checkboxes[i].value) {
                    selectedASUCampus[j].isChecked = checkboxes[i].checked;
                }
            }
        }
    };

    onExportInvoice(){
        //this.gridApi.paginationGoToLastPage();
        const params = {
            columnGroups: true,
            allColumns: true,
            fileName: 'Campus_Buildings_List',
            columnSeparator:''
            
          };
          this.gridApi.exportDataAsCsv(params);
    }

    onFilterCalendarOpen(){
        var aa = document.getElementsByClassName('react-datepicker__tab-loop');
        aa[0].id = "asu_wrapper_calendar";
        var PrevYearBtn = document.getElementsByClassName('react-datepicker__navigation react-datepicker__navigation--previous')[0];
        var NextYearBtn = document.getElementsByClassName('react-datepicker__navigation react-datepicker__navigation--next')[0];
        PrevYearBtn.addEventListener('click', this.handlePrevYearChange);
        NextYearBtn.addEventListener('click', this.handleNextYearChange);
        var SelectedYear = document.getElementsByClassName('react-datepicker__header react-datepicker-year-header')[0].innerText;
        var CurrentMonth= document.getElementsByClassName('react-datepicker__month-'+new Date().getMonth());
        CurrentMonth[0].style.color = Number(SelectedYear) === new Date().getFullYear() ? "#2070CF" : "#000000";
    }

    onFilterCalendarClose(){
        var PrevYearBtn = document.getElementsByClassName('react-datepicker__navigation react-datepicker__navigation--previous')[0];
        var NextYearBtn = document.getElementsByClassName('react-datepicker__navigation react-datepicker__navigation--next')[0];
        if(PrevYearBtn !== undefined) 
            PrevYearBtn.removeEventListener('click', this.handlePrevYearChange);
        if(NextYearBtn !== undefined)
            NextYearBtn.removeEventListener('click', this.handleNextYearChange);
    }

    handlePrevYearChange(){
        var SelectedYear = document.getElementsByClassName('react-datepicker__header react-datepicker-year-header')[0].innerText;
        var CurrentMonth= document.getElementsByClassName('react-datepicker__month-'+new Date().getMonth());
        CurrentMonth[0].style.color = Number(SelectedYear) - 1 === new Date().getFullYear() ? "#2070CF" : "#000000";
    }

    handleNextYearChange(){
        var SelectedYear = document.getElementsByClassName('react-datepicker__header react-datepicker-year-header')[0].innerText;
        var CurrentMonth= document.getElementsByClassName('react-datepicker__month-'+new Date().getMonth());
        CurrentMonth[0].style.color = Number(SelectedYear) + 1 === new Date().getFullYear() ? "#2070CF" : "#000000";
    }

    handlePageClick = data => {
        let selected = data.selected;
        this.setState({ currentPage: selected });
        var scrollPageTop =  document.getElementsByClassName('Ensemble_Content_FullPage');
        if(scrollPageTop[0] !== undefined){
            scrollPageTop[0].scrollIntoView()
        }
    };

    uncheckCheckboxes = () => {
        var checkboxes = document.getElementsByClassName('ASUBuildingInvoiceGeneration');
        [...checkboxes].map(e => e.checked = false)
        selectedASUCampus.map(e => e.isChecked = false)
    }

    async OnGenerateASUPDF(){
        this.setState({isError: false});
        var Data = [];
        for (var i = 0; i < selectedASUCampus.length; i++) {
            if (selectedASUCampus[i].isChecked === true) {
                var Invoice_id_to_be_generated = {
                    "invoiceDate": document.getElementById("FilterCalendar").value,
                    "buildingId": selectedASUCampus[i].building,
                }
                Data.push(Invoice_id_to_be_generated);
            }
        }
        if(Data.length){
            await Data.reduce((promiseChain, arrayItem) => promiseChain.then(() => this.props.ASUGenerateSummaryInvoice(arrayItem)),Promise.resolve());
            this.uncheckCheckboxes();
        }
        else
            this.setState({isError: true});    
    }

    async DownloadExcel(){
        this.setState({isError: false});
        var Data = [];
        for (var i = 0; i < selectedASUCampus.length; i++) {
            if (selectedASUCampus[i].isChecked === true) {
                var Invoice_id_to_be_generated = {
                    "invoiceDate": document.getElementById("FilterCalendar").value,
                    "buildingId": selectedASUCampus[i].building,
                }
                Data.push(Invoice_id_to_be_generated);
            }
        }
        if(Data.length){
            await Data.reduce((promiseChain, arrayItem) => promiseChain.then(() => this.props.DownlodBuildingInvoiceExcel(arrayItem)), Promise.resolve());
            this.uncheckCheckboxes();
        }
        else
            this.setState({isError: true});
        }

    OpenPrintPreview(){
        var CurrentDateTime = new Date(); 
        var CurrentTime = CurrentDateTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        var CurrentDate = (CurrentDateTime.getMonth()+1) + '/' + CurrentDateTime.getDate() + '/' + CurrentDateTime.getFullYear() + ', ' + CurrentTime;
        var printContent = document.getElementById('divPrintWindow').outerHTML;
        var imgURL = document.getElementById('Asu_Logo').src;
        var SelectedDate = document.getElementById('FilterCalendar').value;
        var SelectedCampus = this.state.FilterCampusValue === null ? "All" : this.state.FilterCampusValue;
        var WindowHeight = ((window.screen.height)-200) + 'px';
        var WindowWidth = ((window.screen.width)-10) + 'px';
        var printWindow = window.open('', 'printwindow', 'height='+WindowHeight+', width='+WindowWidth+', resizable=1, scrollbars=yes, layout=1');
        //create a new HEAD with the exact same content as the main page
        var writeMe = ('<html style="overflow: auto !important;"><body style="overflow: visible !important;"><head>' + document.getElementsByTagName('head')[0].innerHTML + '</head>');
        //grab the content of the printMe div and use it on the print page
        writeMe += ("<div style='display:block !important;' class='row row_padding'><div class='col-md-12'>");
        writeMe += ("<div id='asu_print_margin'><img id='asu_Logo' src=" + imgURL + ">");
        writeMe += ("<label class='workOrderlabel' style='float:right;margin-right:16px;margin-top:-25px'>" + CurrentDate + "</label></div>");
        writeMe += ("<label style='height: 15px;padding-left: 15px;'>Campus: " + SelectedCampus  + "</label><hr style='margin-bottom: 4px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'>");
        writeMe += ("<label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;padding-left: 16px; padding-bottom: 3px;'>Date: " + SelectedDate + "</label>");
        writeMe += ("<label style='vertical-align: bottom !important;margin-bottom: 0.3rem !important;float: right; padding-right: 14px;'>" + PrintPaginationText + "</label>");
        writeMe += ("<div id='divPrintPreview'>" + printContent + "</div>");
        writeMe += ("<br/><hr style='margin-bottom: 0px;background-color: gray;height: 2px;border: none;margin-top: 4px;margin-left: 15px;margin-right: 15px;'/><br/>");
        writeMe += ("<label class='print_footer' style='padding-left: 16px; padding-bottom: 8px;'>Tracer Ensemble<br/>© 2021 Trane Technologies | Privacy Policy | Terms of Use<br/>Page 1 of 1</label>");
        writeMe += ("<div style='margin-right:4px'><div style='float:right;'>");
        writeMe += ("<button type='button' class='hide_in_print' style='background: #BBBBBB 0% 0% no-repeat;border: 1px solid #999999;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 80px;height: 30px;float: right; margin-left: 6px; margin-right:10px; width:106px' id='btnPrint' onclick='javascript:window.close();' >Close Window</button>");
        writeMe += ("<button type='button' class='hide_in_print' style='background: #61AE34 0% 0% no-repeat;border: 1px solid #999999;border-radius: 2px;opacity: 1;text-align: center;font-family: Lato;font-size: 12px;letter-spacing: 0.36px;color: #FFFFFF;width: 101px;height: 30px;float: right; margin-left: 6px; id='btnPrint' onclick='javascript:window.print();' >Print</button>");
        writeMe += ("</div><br/>");
        writeMe += ('</body></html>');
        printWindow.document.write(writeMe);
        printWindow.document.close();
        if (window.focus) {
            printWindow.focus();
        } 
    }

    render(UserPreference_response) {

        let Data, Filters_Campus_in_Select_input,StructuredData,FilteredData = [], CampusBillingFilters=[];
        // label = this.props.getLabels;
        Data = this.props.AllCampusInvoices;
        if(selectedASUCampus.length === 0){
                Data.forEach((el,index) => {
                let selectedCampus = {
                    'id': index,
                    'building' : el.building, 
                    'isChecked': false,
                }
                selectedASUCampus.push(selectedCampus);
            });
        }
        let lInvoicelength = 0, lCurrentInvoicelength = 0;
        let PreferedDateFormat = this.props.UserPreference_response;
        dateformat = PreferedDateFormat;
        let CampusInvoiceListTable = [];

        if (this.props.CampusBillingFilters !== undefined && this.props.CampusBillingFilters !== null && this.props.CampusBillingFilters.length) {
            CampusBillingFilters = this.props.CampusBillingFilters;
            Filters_Campus_in_Select_input = CampusBillingFilters.map(el => (
                    <option id={el} value={el}>{el}</option>
            ));
        }

        if (this.state.isError) {
            var errormsg = <p style={ErrorPadding}>
                            <Icon name='exclamation triangle' style={ErrorSign}/>
                            <b>Select one or more buildings to perform this action.</b>
                           </p>
        }

        if(Data !== undefined && Data !== null && Data.length){
            StructuredData = [];
            var ItemRows = [];
            Data.forEach((el,index) => {
                var lineitem = {
                    "checkboxfield": selectedASUCampus[index].isChecked,
                    "siteName" : el.siteName, 
                    "building" : el.building, 
                    "campus" : el.campus,
                    "on_Peak_kw" :  Conversions.formatNumber(PreferedDateFormat,el.on_Peak_kw),
                    "off_Peak_kw" :  Conversions.formatNumber(PreferedDateFormat,el.off_Peak_kw),
                    "kWh_Total" :  Conversions.formatNumber(PreferedDateFormat,el.kWh_Total),
                    "kWh_Cost" :  "$" + Conversions.formatNumber(PreferedDateFormat,el.kWh_Cost),
                    "tonHr_Total" : Conversions.formatNumber(PreferedDateFormat,el.tonHr_Total),
                    "tonHr_Cost" : "$" +  Conversions.formatNumber(PreferedDateFormat,el.tonHr_Cost),
                    "heating_mmBTU" : Conversions.formatNumber(PreferedDateFormat,el.heating_mmBTU),
                    "heating_mmBTU_Cost" : "$" +  Conversions.formatNumber(PreferedDateFormat,el.heating_mmBTU_Cost),
                    "total_mmBTU" :  Conversions.formatNumber(PreferedDateFormat,el.total_mmBTU),
                    "om_Utility_Service_Charge" : "$" +  Conversions.formatNumber(PreferedDateFormat,el.om_Utility_Service_Charge),
                    "om_Capital_Service_Charge" : "$" +  Conversions.formatNumber(PreferedDateFormat,el.om_Capital_Service_Charge),
                    "sewer_Service_Charge" : "$" +  Conversions.formatNumber(PreferedDateFormat,el.sewer_Service_Charge),
                    "water_Service_Charge" : "$" +  Conversions.formatNumber(PreferedDateFormat,el.water_Service_Charge),
                    "total_Cost" : "$" +  Conversions.formatNumber(PreferedDateFormat,el.total_Cost)
                }
                StructuredData.push(lineitem);
            });

            var TempFilteredData = StructuredData.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            TempFilteredData.forEach(lineitem => {
                var trItem = <tr>
                <td>{lineitem.siteName}</td>
                <td>{lineitem.campus}</td>
                <td>{lineitem.on_Peak_kw}</td>
                <td>{lineitem.off_Peak_kw}</td>
                <td>{lineitem.kWh_Total}</td>
                <td>{lineitem.kWh_Cost}</td>
                <td>{lineitem.tonHr_Total}</td>
                <td>{lineitem.tonHr_Cost}</td>
                <td>{lineitem.heating_mmBTU}</td>
                <td>{lineitem.heating_mmBTU_Cost}</td>
                <td>{lineitem.total_mmBTU}</td>
                <td>{lineitem.om_Utility_Service_Charge}</td>
                <td>{lineitem.om_Capital_Service_Charge}</td>
                <td>{lineitem.sewer_Service_Charge}</td>
                <td>{lineitem.water_Service_Charge}</td>
                <td style={{'font-weight':'bolder'}}>{lineitem.total_Cost}</td>
                </tr>
                ItemRows.push(trItem);
            });
            CampusInvoiceListTable = <div className="table_container table_border" id="divPrintWindow" style={{'margin-bottom':'0px', 'margin-right':'15px','margin-left':'15px'}}>
                <Table striped responsive className="Custom_table fixed_layout" >
                    <tbody className="cell_container">
                        <tr>
                            <th className="asu_print_th asu_print_th_0" width="80px">Building</th>
                            <th className="asu_print_th asu_print_th_1"width="80px">Campus</th>
                            <th className="asu_print_th">On-Peak<br/> kW</th>
                            <th className="asu_print_th">Off-Peak<br/> kW</th>
                            <th className="asu_print_th">kWh<br/> Total</th>
                            <th className="asu_print_th">kWh<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_6">TonHr<br/> Total</th>
                            <th className="asu_print_th asu_print_th_7">TonHr<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_8">Heating<br/> mmBTU</th>
                            <th className="asu_print_th asu_print_th_9">Heating<br/> mmBTU<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_10">Total<br/> mmBTU</th>
                            <th className="asu_print_th asu_print_th_11" width="87px">{"O&M Utility"}<br/>Service<br/>Charge</th>
                            <th className="asu_print_th asu_print_th_12" width="92px">{"O&M Capital"}<br/>Service<br/>Charge</th>
                            <th className="asu_print_th asu_print_th_13">Sewer <br/>Service<br/> Charge</th>
                            <th className="asu_print_th asu_print_th_14">Water <br/>Service <br/>Charge</th>
                            <th className="asu_print_th">Total <br/>Cost</th>
                        </tr>
                        {ItemRows}
                    </tbody>
                </Table>
            </div>
             
            lInvoicelength = TempFilteredData.length;
            pagesCount = Math.ceil(TempFilteredData.length / this.state.pageSize);
            FilteredData = TempFilteredData.slice(this.state.currentPage * this.state.pageSize, (this.state.currentPage + 1) * this.state.pageSize);
            if(FilteredData.length !== undefined);
                lCurrentInvoicelength = FilteredData.length;
        }else{
            CampusInvoiceListTable = <div className="table_container table_border" id="divPrintWindow" style={{'margin-bottom':'0px', 'margin-right':'15px','margin-left':'15px'}}>
                <Table striped responsive className="Custom_table fixed_layout" >
                    <tbody className="cell_container">
                        <tr>
                            <th className="asu_print_th asu_print_th_0" width="80px">Building</th>
                            <th className="asu_print_th asu_print_th_1"width="80px">Campus</th>
                            <th className="asu_print_th">On-Peak<br/> kW</th>
                            <th className="asu_print_th">Off-Peak<br/> kW</th>
                            <th className="asu_print_th">kWh<br/> Total</th>
                            <th className="asu_print_th">kWh<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_6">TonHr<br/> Total</th>
                            <th className="asu_print_th asu_print_th_7">TonHr<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_8">Heating<br/> mmBTU</th>
                            <th className="asu_print_th asu_print_th_9">Heating<br/> mmBTU<br/> Cost</th>
                            <th className="asu_print_th asu_print_th_10">Total<br/> mmBTU</th>
                            <th className="asu_print_th asu_print_th_11" width="87px">{"O&M Utility"}<br/>Service<br/>Charge</th>
                            <th className="asu_print_th asu_print_th_12" width="92px">{"O&M Capital"}<br/>Service<br/>Charge</th>
                            <th className="asu_print_th asu_print_th_13">Sewer <br/>Service<br/> Charge</th>
                            <th className="asu_print_th asu_print_th_14">Water <br/>Service <br/>Charge</th>
                            <th className="asu_print_th">Total <br/>Cost</th>
                        </tr>
                        <tr><td colSpan="7"/><td colSpan="5">No Records Found</td></tr>
                    </tbody>
                </Table>
            </div>
        }
        PrintPaginationText = (lInvoicelength !== 0 ? this.state.currentPage*50+1 : 0) + "-" + ((this.state.currentPage*50)+lCurrentInvoicelength) + " of " + lInvoicelength + " records";
        
        return (
            
                this.state.redirect ? <ASUBuildingInvoiceDetails building={this.state.building} siteName={this.state.siteName} SelectedYear={this.state.FilterDate.getFullYear()} UpdateRedirection={this.UpdateRedirection} /> :
            <div className="main_container">
                <div className="border_container">&nbsp;
                    <div className="main_container" style={{ 'padding-top': '0px' }}>
                        <div className="row row_padding" style={{'padding-bottom':'20px'}}>
                            <div className="col-md-12">
                                <span className="lbl_asu_heading">Campus</span>
                                <div class="ASUdropdown" style={{float:'right', marginLeft:'8px'}}>
                                    <button type="button" class="btn-gray" style={{backgroundColor:'#666666'}}><span className="ASUdropdowntxt">PRINT SCREEN</span><i className="arrowi down" style={{float:'right'}}></i></button>
                                    <div class="ASUdropdown-content">
                                        <a onClick={this.OpenPrintPreview}>Print...</a>
                                        <a onClick={() => {this.onExportInvoice()}}>Export as Excel</a>
                                    </div>
                                </div>
                                <div class="ASUdropdown" style={{float:'right', marginLeft:'20px'}}>
                                    <button type="button" class="btn-success" style={{backgroundColor:'#61AE34'}}><span className="ASUdropdowntxt">DOWNLOAD INVOICE</span><i className="arrowi down" style={{float:'right'}}></i></button>
                                    <div class="ASUdropdown-content">
                                        <a onClick={() => { this.OnGenerateASUPDF() }}> Download as PDF</a>
                                        <a onClick={() => { this.DownloadExcel() }}>Download as Excel</a>
                                    </div>
                                </div>
                                {errormsg}
                            </div>
                        </div>
                        <div className="row row_padding" style={{'margin-right':'0px','padding-bottom':'20px'}}>
                            <div className="col-md-6">
                                <label style={{ "margin-right": "10px" }} className="lbl_asu_filter_text">Date:</label>
                                <label style={{'cursor':'pointer'}}>
                                   <div className="pm_calendardiv" style={{"margin-top":"0px"}}> 
                                        <FaRegCalendarAlt className="pm_calendarbox" />
                                    </div>
                                    <DatePicker selected={this.state.FilterDate} onChange={date => this.setFilterDate(date)} 
                                    id="FilterCalendar"
                                    onCalendarOpen={this.onFilterCalendarOpen}
                                    onCalendarClose={this.onFilterCalendarClose}
                                    dateFormat={"MMM yyyy"} 
                                    showMonthYearPicker={true} />
                                   
                                </label>
                                <label className="lbl_asu_filter_text marging_left_15">Campus:</label>
                                <select ref='campus_in_Select_input' style={{ "margin-left": "10px" }} className="pmminimal pm-dropdown" value={this.state.FilterCampusValue} onChange={this.OnFilterCampusChange}>
                                    <option id="All" value="All">All</option>
                                    {Filters_Campus_in_Select_input}
                                </select>
                                <Button style={{"margin-left":"15px"}} className="asu-applybutton" onClick={() => { this.OnFilterChange() }}>{"APPLY"}</Button>
                            </div>
                            <div className="col-md-6" style={{'padding-right':'0px'}}>
                                <label style={{ fontFamily: 'lato', fontSize: '13px', fontWeight: 'bold', color: 'black', marginLeft: '10px', float: 'right', 'margin-top': '4px' }}>{PrintPaginationText}</label>
                                <span className="pm_outersearchbox" style={{ float: 'right' }}>
                                    <input type="text" className="pm_searchbox" style={{ paddingLeft: '10px', 'margin-top': '3px' }} placeholder="Enter value..." onChange={this.searchUpdated} ref='asu_campus_search_value' />
                                </span>
                                <label className="lbl_asu_filter_text" style={{ 'float': 'right', 'margin-top': '4px' }}>{"Search:"}</label>
                            </div>
                        </div>
                        <div className="row row_padding pm_pagination_top" style={{'margin-left':'0px'}}>
                            <div className="col-md-7">
                                <ReactPaginate
                                    previousLabel={'Prev'}
                                    nextLabel={'Next'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me pagination_margin'}
                                    breakLinkClassName={'pagination_link_color'}
                                    pageCount={pagesCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={10}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={'pagination pagination_container_margin'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    disabledClassName={'pagination_disable_link'}
                                    pageClassName={'pagination_margin'}
                                    pageLinkClassName={'pagination_link_color'}
                                    previousClassName={'pagination_margin'}
                                    previousLinkClassName={'pagination_link_color'}
                                    nextClassName={'pagination_margin'}
                                    nextLinkClassName={'pagination_link_color'}
                                    forcePage={this.state.currentPage}
                                />
                            </div>
                        </div>
                        <div className="table_container table_border">
                            <div className="ag-theme-alpine" style={ { 'width': '100%'} } domLayout='autoHeight'>
                               <AgGridReact
                                    columnDefs={this.state.columnDefs}
                                    rowData={FilteredData}
                                    domLayout= 'autoHeight'
                                    overlayNoRowsTemplate='No Records Found'
                                    overlayLoadingTemplate='Loading...'
                                    suppressCellSelection={true}
                                    suppressMovableColumns={true}
                                    onGridReady={this.onGridReady.bind(this)}
                                    enableSorting={true} 
                                >
                              </AgGridReact>
                           </div>
                        </div>
                        <div className="row row_padding pm_pagination" style={{'margin-left':'0px'}}>
                            <div className="col-md-7">
                                <ReactPaginate
                                    previousLabel={'Prev'}
                                    nextLabel={'Next'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me pagination_margin'}
                                    breakLinkClassName={'pagination_link_color'}
                                    pageCount={pagesCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={10}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={'pagination pagination_container_margin'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    disabledClassName={'pagination_disable_link'}
                                    pageClassName={'pagination_margin'}
                                    pageLinkClassName={'pagination_link_color'}
                                    previousClassName={'pagination_margin'}
                                    previousLinkClassName={'pagination_link_color'}
                                    nextClassName={'pagination_margin'}
                                    nextLinkClassName={'pagination_link_color'}
                                    forcePage={this.state.currentPage}
                                />
                            </div>
                        </div>
                        <div style={{"display":"none"}}>
                            {CampusInvoiceListTable}
                        </div>
                        <img id='Asu_Logo' alt="Trane1" src={ASULogo} style={{"display":"none"}} />
                    </div>
                </div>
            </div>
            
        );
    }
};
const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        AllCampusInvoices: state.ASUBillingInvoicesRootReducer.AllCampusInvoices,
        CampusBillingFilters: state.ASUBillingInvoicesRootReducer.CampusBillingFilters,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference
    };
};
const mapDispatchToProps = dispatch => {
    return {
        GetAllCampusInvoices : (Month,Year,Campus) => dispatch(GetAllCampusInvoices(Month,Year,Campus)),
        GetCampusBillingFilters : () => dispatch(GetCampusBillingFilters()),
        ASUGenerateSummaryInvoice: (data) => dispatch(ASUGenerateSummaryInvoice(data)),
        DownlodBuildingInvoiceExcel: (BuildingDetails) => dispatch(DownlodBuildingInvoiceExcel(BuildingDetails))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ASUInvoices);